import { HeroSettings } from '../types'

export const createDefaultHeroSettings = (): HeroSettings => ({
  main_heading: 'Independent Equity Research',
  highlight_text_1: 'built on',
  highlight_text_2: 'Discipline, Transparency & Risk Management',
  hero_description:
    "We don't predict - we calculate. Get disciplined, data-driven equity research with clear entries, smart exits, and defined risk-to-reward on every call.",
  profile_image_url: null,
  feature_cards: [
    { title: 'Research Driven Insights', subtitle: '' },
    { title: 'Systematic Algo Strategies', subtitle: '' },
    { title: 'Risk First Framework', subtitle: '' },
    { title: 'Institutional Research Process', subtitle: '' },
  ],
  analyst_statistics: [
    { value: '580+', label: 'Total Calls' },
    { value: '1000+', label: 'Clients' },
    { value: '8+ Yrs', label: 'Experience' },
    { value: '1:2.4', label: 'Risk:Reward' },
  ],
  trust_items: [
    { title: '10K+', subtitle: 'Investors Trust Us' },
    { title: 'SEBI Registered', subtitle: 'Research Analyst' },
    { title: 'Research Backed', subtitle: 'Methodology' },
    { title: 'Secure &', subtitle: 'Confidential' },
    { title: '98%', subtitle: 'Client Satisfaction' },
  ],
})
